import { PriceBand, Seat } from '@/types'

import { create } from 'zustand'

// Define a type for the user object

// Define the store's state
type useEventState = {
  eventId: string | undefined
  eventStatus: string | undefined
  mapSeats: Seat[]
  priceBands: PriceBand[]
  selectedSeats: Seat[]
  searchingSeats: boolean
  seatMapOn: boolean
  maxDiscount: number
  setEventId: (eventId: string | undefined) => void
  setEventStatus: (bookingNumber: string | undefined) => void
  setPriceBands: (priceBands: PriceBand[]) => void
  setMapSeats: (mapSeats: Seat[]) => void
  setSelectedSeats: (selectedSeats: Seat[]) => void
  setSearchingSeats: (searchingSeats: boolean) => void
  setSeatMapOn: (seatMapOn: boolean) => void
  setMaxDiscount: (maxDiscount: number | undefined) => void
}

// Create the store
const useEventStore = create<useEventState>((set) => ({
  eventId: undefined,
  eventStatus: undefined,
  mapSeats: [],
  priceBands: [],
  selectedSeats: [],
  searchingSeats: false,
  seatMapOn: false,
  maxDiscount: 0,
  setEventId: (eventId) => set({ eventId }),
  setEventStatus: (eventStatus) => set({ eventStatus }),
  setPriceBands: (priceBands) => set({ priceBands }),
  setMapSeats: (mapSeats) => set({ mapSeats }),
  setSelectedSeats: (selectedSeats) => set({ selectedSeats }),
  setSearchingSeats: (searchingSeats) => set({ searchingSeats }),
  setSeatMapOn: (seatMapOn) => set({ seatMapOn }),
  setMaxDiscount: (maxDiscount) => set({ maxDiscount }),
}))

export default useEventStore
